import {
  LastDealsTableColumn,
  LastDealsTableColumnId,
  LastDealsTableSorting,
} from '@prlw/core/deals/types/last-deals.types';

export const lastDealsTableColumns: LastDealsTableColumn[] = [
  {
    name: '№ Сделки',
    id: LastDealsTableColumnId.DEAL_NUMBER,
    cellSizeMin: '105px',
  },
  {
    name: 'Цена',
    id: LastDealsTableColumnId.PRICE,
    cellSizeMin: '50px',
  },
  {
    name: 'Объем',
    id: LastDealsTableColumnId.VOLUME,
    cellSizeMin: '45px',
  },
  {
    name: 'Дата',
    id: LastDealsTableColumnId.DATE,
    cellSizeMin: '85px',
  },
  {
    name: 'Время',
    id: LastDealsTableColumnId.TIME,
    cellSizeMin: '70px',
  },
];

export const lastDealsTableSortDefaults: LastDealsTableSorting[] = [
  { columnId: LastDealsTableColumnId.VOLUME, direction: 'ASC' },
  { columnId: LastDealsTableColumnId.PRICE, direction: 'ASC' },
  { columnId: LastDealsTableColumnId.DEAL_NUMBER, direction: 'ASC' },
  { columnId: LastDealsTableColumnId.TIME, direction: 'ASC' },
  { columnId: LastDealsTableColumnId.DATE, direction: 'ASC' },
];
